import * as React from 'react';

import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  variant?: 'default' | 'primary';
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, variant = 'default', ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-12 w-full rounded-[10px] px-4 py-3 text-sm placeholder:text-muted-foreground dark:placeholder:text-[#898989] focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50',
          // Стили по умолчанию
          variant === 'default' &&
            'bg-background dark:bg-[#3a3f47] text-foreground dark:text-white',
          // Стили для primary
          variant === 'primary' &&
            'bg-background dark:bg-[#3a3f47] text-foreground dark:text-white',
          error && 'border border-destructive',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

// Темная версия инпута для использования в других частях проекта
export const InputDark = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-12 w-full rounded-[10px] border border-border dark:border-[#4a4f57] bg-background dark:bg-[#3a3f47] backdrop-blur-sm px-4 py-3 text-base text-foreground dark:text-white placeholder:text-muted-foreground dark:placeholder:text-[#898989] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
InputDark.displayName = 'InputDark';

export { Input };
